export default {
    name: 'Webcam',
    dimensions: { width: 20, height: 24 },
    content: `
    <g fill="currentColor" stroke="none" clip-path="url(#clip0_6380_47020)">
        <path d="M10 19.25C14.9706 19.25 19 15.2206 19 10.25C19 5.27944 14.9706 1.25 10 1.25C5.02944 1.25 1 5.27944 1 10.25C1 15.2206 5.02944 19.25 10 19.25Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 13.25C11.6569 13.25 13 11.9069 13 10.25C13 8.59315 11.6569 7.25 10 7.25C8.34315 7.25 7 8.59315 7 10.25C7 11.9069 8.34315 13.25 10 13.25Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 5.25C10.5523 5.25 11 4.80228 11 4.25C11 3.69772 10.5523 3.25 10 3.25C9.44772 3.25 9 3.69772 9 4.25C9 4.80228 9.44772 5.25 10 5.25Z" fill="currentColor"/>
        <path d="M1 10.25H7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13 10.25H19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7 23.25H13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_6380_47020">
            <rect width="20" height="24" fill="currentColor" transform="translate(0 0.25)"/>
        </clipPath>
    </defs>
  `
};